import cx from 'clsx';
import React from 'react';

import GhostTile from '@/components/modular-grid/GhostTile';

import styles from './TallSingleBlock.module.scss';

const ghostsFiller = new Array(6).fill(null);

export default function TallSingleBlockGhost() {
  return (
    <div className={cx(styles.layout)}>
      {ghostsFiller.map((_, index) => {
        return <GhostTile key={index} />;
      })}
    </div>
  );
}
